<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>人脸识别</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="content-main">
                <div
                    v-if="[-1, 0, 1, 5, 11].includes(userInfo.authenticationStatus)"
                    class="imgList"
                >
                    <div class="top">
                        <dl>
                            <dt>
                                <strong>1</strong>
                                <p>第一步：微信扫码</p>
                            </dt>
                            <dd>请使用微信扫描下方二维码进行实名认证</dd>
                        </dl>
                        
                        <el-image
                            :src="qrBase64"
                            alt=""
                            class="dataPng"
                            style="margin-top: 0%"
                        >
                        </el-image>
                    </div>
                    <el-button round type="primary" @click="reload">{{
                        msg
                    }}</el-button>
                    <p class="error">
                        <i class="el-icon-warning-outline"></i>若认证失败请<span @click="reload">刷新页面</span>重置二维码
                    </p>
                </div>
                <div class="right">
                    <img src="@/assets/images/yangli.jpg" alt="">
                </div>
            </div>
        </div>
    </el-row>
</template>

<script>
import { faceApply } from "@http/user_center/faceIdent";
import { identification } from "@http/user_center/userInfo";

export default {
    name: "",
    data() {
        return {
            dataPng: require("@/assets/images/error.png"),
            huancun: require("@/assets/images/huancun.gif"),
            isShow: true,
            qrBase64: "",
            timer: null,
            bizToken: "",
            userInfo: {},
            msg: "正在获取认证状态，请稍后···",
        };
    },
    created() {
        this.reload();
    },
    computed: {
        channelCodeValue() {
            return this.$store.state.config.channelCodeValue;
        },
    },
    mounted() {
        zhuge.track("用户中心_人脸识别开始认证", {
            渠道: this.channelCodeValue,
        });
    },
    methods: {
        async init() {
            let clientId = this.$getlocalStorage("queryData")
                ? this.$getlocalStorage("queryData").clientId
                : "";
            let res = await faceApply({ clientId });
            console.log(res);
            this.qrBase64 = `data:image/jpg;base64,${res.qrBase64}`;
            this.bizToken = res.bizToken;
            if (res) this.msg = "认证成功，刷新页面";
        },
        async reload() {
            this.userInfo = await identification({});
            if (
                [-1, 0, 1, 5, 11].includes(this.userInfo.authenticationStatus)
            ) {
                this.init();
            } else {
                this.$msg("您已认证成功", "success");
                this.$store.dispatch('userInfo/setLawyerInfo', {})
                zhuge.track("用户中心_个人认证成功", {
                    渠道: this.channelCodeValue,
                    用户行为: "实名认证",
                });
                setTimeout(() => {
                    if(this.$getlocalStorage("queryData")?.from==='lawcase'){
                        zhuge.track('律师咨询_实名认证成功',{'端':'PC'},()=>{
                          this.$store.dispatch('userInfo/setLawyerInfo', {})
                            if(this.$getlocalStorage("queryData")?.to){
                              window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication?to=${this.$getlocalStorage("queryData").to}&randomKey=${this.$getlocalStorage("queryData").randomKey || ''}`
                            }else{
                                window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication`
                            }                           
                        })
                    }else{
                        this.$router.push({
                            path: "/userCenter/AuthenticationName",
                        });
                    }
                    
                }, 1500);
            }
        },
    },
    destroyed() {},
};
</script>

<style scoped lang='less'>
.content-main{
    display: flex;
    justify-content: center;
    margin-top: 18px;
    .imgList {
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        width: 455px;
        margin-right:16px;
        border: 1px solid #EEF0F3;
        text-align: center;
        box-shadow: 0px 1px 3px 0px rgba(20,30,50,0.04);
        border-radius: 10px;
        padding: 23px 25px;
        box-sizing: border-box;
        .top{
            dl{
                margin-bottom: 32px;
                dt{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    strong{
                        display: flex;
                        width: 22px;
                        height: 22px;
                        font-size: 12px;
                        color: #fff;
                        border-radius: 11px;
                        background: #3f7df7;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                    }
                    p{
                        color: #1F2937;
                        font-size: 20px;
                        font-weight: bold;
                    }
                }
                dd{
                    margin-top: 8px;
                    font-size: 16px;
                    color: #6B7280;
                    font-weight: 400;
                }
            }
            .el-image {
                width: 320px;
                height: 320px;
                box-shadow: 0px 6px 23px 0px rgba(20,30,50,0.08);
                border-radius: 10px;
            }
        }
        .el-button {
            margin-top: 16px;
        }

        /deep/ .image-slot {
            background: #f5f7fa;
            height: 100%;
        }
    }
    .right{
        max-width:695px;
        border: 1px solid #EEF0F3;
        box-shadow: 0px 1px 3px 0px rgba(20,30,50,0.04);
        border-radius: 10px;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
}
p {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}

b {
    color: #3f7df7;
}
.huancun {
    height: 75px;
    width: 75px;
    margin-bottom: 10px;
}
#canvas {
    width: 50% !important;
    height: auto !important;
    left: 127px;
    top: 237px;
}
.error {
    margin-top: 16px;
    font-size: 14px;
    color: #999;
    display: flex;
    align-items: center;
    .el-icon-warning-outline{
        color:#3f7df7;
        font-size: 16px;
        margin-right: 2px;
    }
    span {
        color: #3f7df7;
        cursor: pointer;
    }
}
// .dataPng {
//     width: 163px;
//     height: 128px;
//     margin: 30px auto;
//     background-size: cover;
//     margin-top: 10%;
// }
</style>
